import { Heart } from "lucide-react";
import { getTenantConfig } from "@/lib/tenant";

export type MinimalFooterProps = {
  compact?: boolean;
};

export function MinimalFooter({ compact = false }: MinimalFooterProps = {}) {
  const tenant = getTenantConfig();
  const isMindfulMe = tenant.brandName === "MindfulMe";

  return (
    <footer
      className={`bg-surface-canvas text-center ${compact ? "py-8" : "py-16"}`}
      data-testid="minimal-footer"
    >
      <div className="mx-auto flex max-w-xl flex-col items-center gap-3 px-5">
        {isMindfulMe ? (
          <span className="flex items-center gap-2 font-black text-slate-900 tracking-tight text-xl">
            <span className="relative flex size-8 items-center justify-center">
              <span className="absolute left-0 size-6 rounded-full bg-indigo-600" />
              <span className="absolute right-0 size-6 rounded-full bg-orange-500 opacity-90 mix-blend-multiply" />
            </span>
            <span>Mindful<span className="text-indigo-600">Me</span></span>
          </span>
        ) : (
          <>
            <span
              className="inline-flex size-10 items-center justify-center rounded-full bg-primary text-primary-foreground"
              aria-hidden="true"
            >
              <Heart className="size-4 fill-current" />
            </span>
            <span className="text-xl font-extrabold tracking-tight text-foreground">
              {tenant.brandName}
            </span>
          </>
        )}
        <p className="max-w-sm text-sm text-muted-foreground">
          {isMindfulMe
            ? "Personalized insights & 8 Expressions of Love assessment report for couples and individuals."
            : "Short, science-backed courses for the parenting moments that feel impossible."}
        </p>
        <p className="text-xs text-text-subtle">© 2026 {tenant.brandName}</p>
      </div>
    </footer>
  );
}
